import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IdInfo } from 'src/app/shared/models/id-info.model';
import { LimitedMember } from 'src/app/shared/models/limited-member';
import { Member } from 'src/app/shared/profile/profile/member.model';
import { ProfileService } from 'src/app/shared/profile/profile/profile.service';
import { AppService } from 'src/app/shared/services/app.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { Location } from '@angular/common';
import { AddCheckinService } from 'src/app/usher/check-in/add-checkin/add-checkin.service';

@Component({
    selector: 'app-qr-self-checkin',
    templateUrl: './qr-self-checkin.component.html',
    styleUrls: ['./qr-self-checkin.component.scss'],
    standalone: false
})
export class QrSelfCheckinComponent implements OnInit, AfterViewInit {

  userId: string;
  eventId: number;
  members : LimitedMember[] = []; 
  isLoading: boolean = true;
  isConfirmed: boolean = false;
  verifyPhone: boolean = false;
  failedToVerify: boolean = true;
  dial_code: string = "+1";
  phoneNumber: string = '';
  createdBy:string = '';
  QRCode: string = '' ;
  isOpen: boolean = false;
  count: number = 0;

  constructor(
    private route: ActivatedRoute,
    private profileService: ProfileService,
    public globalService: GlobalService, 
    private _addCheckinService: AddCheckinService,  
    private _location: Location,
    private _router: Router, 
    private appService: AppService ) { }

  async ngOnInit() {
    this.isLoading = true; 
    this.eventId = parseInt(this.route.snapshot.params.eventId);    
    this.userId = localStorage.getItem('CSBarcodeID');
    if (this.userId != null)
      this.createdBy = "user-"+this.userId;
    if (this.userId != null && this.userId.length == 36) {
      this.isConfirmed = true;
      await this.LoadMembers(this.userId);
    }

    this.isLoading = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = this.globalService.Get('SELF_CHECKIN');
    });
  }        

  async LoadMembers(userId){
    this.members =  await this.profileService.getLimitedMembers(userId);
    this.QRCode = '@'+ this.userId + '#' + this.members.filter(a => a.checked == true).map(b => b.id).join('X') + '%';
  }

  clearCellPhone() {   
  } 

  failedVerification() { 
      this.verifyPhone = false;
      this.failedToVerify = true;
  }

  async ConfirmCellPhone(phoneNumber)
  {
    this.isLoading = true;
    this.phoneNumber = phoneNumber;
    var user = await this.profileService.getUserIdByPhoneNumber(phoneNumber);
    this.userId = user['userId'];
    if (this.userId != null && this.userId.length == 36) {
      this.createdBy = "user-"+this.userId;
      this.isConfirmed = true;
      let tenant = localStorage.getItem('tenant')
      localStorage.setItem('CSBarcodeID', this.userId);
      this.appService.sendToNative(this.userId, tenant);
      await this.LoadMembers(this.userId);
      this.isLoading = false;
    }
  }  

  toggleMember(member) {
    member['checked'] = !member['checked'];
    this.QRCode = '';
    if (this.members.filter(a => a.checked == true).length > 0)
      this.QRCode = '@'+ this.userId + '#' + this.members.filter(a => a.checked == true).map(b => b.id).join('X') + '%';
  }

  async submitCheckin() {
    this.isLoading = true;
    var checkedMembers: LimitedMember[] = this.members.filter(
      (a) => a['checked'] == true
    );
    var ret = await this._addCheckinService.AddCheckIn(
      this.eventId,
      checkedMembers.map((a) => a.id),
      this.userId,
      this.createdBy
    );
    this.isLoading = false;
    this.isOpen = true;
    var waitTime = 10000;
    this.count = checkedMembers.length;
    setTimeout(() => {
      this.isOpen = false;
      this._router.navigate(['/home']);
    }, waitTime);
  }

  isChecked() { 
    return this.members.filter(a => a.checked == true).length > 0;
  }

} 
  